module.exports = __webpack_public_path__ + "static/img/house-min.a6441ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/house-min.jpg
// module id = 0HzI
// module chunks = 1